import { ComponentLoader } from '@bythepixel/component-loader';
import xhrModalLink from './xhrModalLink';
import TrailerAnimation from '../components/trailerAnimation';

window.trailerBuildComponents = new ComponentLoader(document, [
  xhrModalLink,
  TrailerAnimation,
]);
